<div class="container-fluid vh-auto">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="course-heading text-start">Course Outcome</h3>
  </div>
  <p class="sub-head text-start">
    What skills and Knowledge will students have after completing this couse?
  </p>

  <div class="modal-form">
    <form [formGroup]="createCourseForm">
      <div class="mb-4">
        <textarea formControlName="course_outcomes" class="form-control"
		 placeholder="summarize the course outcome in clear points..." rows="10"></textarea>
    </div>

      
    </form>
  </div>

  <div class="d-flex justify-content-between align-items-center">
    <button type="button" class="btn-cancel py-2 mt-2" (click)="goToPrePage()">
      <mat-icon class="icon-middle me-2">chevron_left</mat-icon> Previous
    </button>

    <button type="submit" class="btn-add mb-2" (click)="goToNextPage()" [disabled]="createCourseForm.invalid">
      Next <mat-icon class="icon-middle">chevron_right</mat-icon>
    </button>
  </div>
</div>
